import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { z } from "zod";
import { Button } from "./ui/button";
import { Textarea } from "./ui/textarea";
import { Label } from "./ui/label";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "./ui/select";
import { Loader2 } from "lucide-react";

const reviewSchema = z.object({
  observatii: z.string().optional(),
  diagnostic: z.string().optional(),
  recomandari: z.string().optional(),
  apt_pierdut: z.string().optional(),
  note: z.string().optional(),
});

export const ReviewForm = ({ onSubmit, isLoading = false, onCancel }) => {
  const {
    register,
    handleSubmit,
    reset,
    setValue,
    watch,
  } = useForm({
    resolver: zodResolver(reviewSchema),
    defaultValues: {
      observatii: "",
      diagnostic: "",
      recomandari: "",
      apt_pierdut: "",
      note: "",
    },
  });

  const handleFormSubmit = async (data) => {
    await onSubmit(data);
    reset();
  };

  return (
    <form onSubmit={handleSubmit(handleFormSubmit)} className="space-y-4">
      {/* Rezultat Aviz */}
      <div className="space-y-2">
        <Label htmlFor="apt_pierdut">Rezultat Aviz Medico-Sportiv</Label>
        <Select
          value={watch("apt_pierdut")}
          onValueChange={(value) => setValue("apt_pierdut", value)}
        >
          <SelectTrigger data-testid="review-apt-pierdut">
            <SelectValue placeholder="Selectați rezultatul" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="APT">APT</SelectItem>
            <SelectItem value="INAPT">INAPT</SelectItem>
            <SelectItem value="PIERDUT">PIERDUT</SelectItem>
            <SelectItem value="TEMPORAR INAPT">TEMPORAR INAPT</SelectItem>
          </SelectContent>
        </Select>
      </div>

      {/* Observații */}
      <div className="space-y-2">
        <Label htmlFor="review-observatii">Observații Clinice</Label>
        <Textarea
          id="review-observatii"
          data-testid="review-observatii"
          placeholder="Observații din consultație"
          rows={2}
          {...register("observatii")}
        />
      </div>

      {/* Diagnostic */}
      <div className="space-y-2">
        <Label htmlFor="review-diagnostic">Diagnostic</Label>
        <Textarea
          id="review-diagnostic"
          data-testid="review-diagnostic"
          placeholder="Diagnostic medical"
          rows={2}
          {...register("diagnostic")}
        />
      </div>

      {/* Recomandări */}
      <div className="space-y-2">
        <Label htmlFor="review-recomandari">Recomandări</Label>
        <Textarea
          id="review-recomandari"
          data-testid="review-recomandari"
          placeholder="Recomandări medicale"
          rows={2}
          {...register("recomandari")}
        />
      </div>

      {/* Note */}
      <div className="space-y-2">
        <Label htmlFor="review-note">Note Adiționale</Label>
        <Textarea
          id="review-note"
          data-testid="review-note"
          placeholder="Alte observații"
          rows={2}
          {...register("note")}
        />
      </div>

      {/* Actions */}
      <div className="flex justify-end gap-2">
        {onCancel && (
          <Button
            type="button"
            variant="outline"
            onClick={onCancel}
            data-testid="cancel-review-btn"
          >
            Anulează
          </Button>
        )}
        <Button
          type="submit"
          data-testid="submit-review-btn"
          disabled={isLoading}
        >
          {isLoading && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}
          Adaugă Consultație
        </Button>
      </div>
    </form>
  );
};
